import { jsxs as e, Fragment as h, jsx as t } from "react/jsx-runtime";
import "react";
import { SectionedContent as d } from "../SectionedContent/SectionedContent.js";
import { GenericList as p } from "../GenericList/GenericList.js";
import { p as c } from "../../index-DB0QlRo7.mjs";
function y({
  series: n,
  castStr: a,
  showUpcoming: i,
  type: r,
  nextAirDates: o
}) {
  const l = () => o.length > 0 ? /* @__PURE__ */ e("div", { className: "upcoming-airings", children: [
    /* @__PURE__ */ t("h3", { className: "h5", children: "Upcoming Airings" }),
    /* @__PURE__ */ t(p, { list: o, classname: "upcoming-airings__list" })
  ] }) : /* @__PURE__ */ e("div", { className: "upcoming-airings", children: [
    /* @__PURE__ */ t("h3", { className: "h5", children: "Upcoming Airings" }),
    /* @__PURE__ */ t("p", { children: r === "series" ? c(`This show doesn't have any episodes scheduled in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.`) : c(`This movie doesn't have any airings in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href="/schedule" className="inline-anchor">full schedule</a> to see what shows are airing.`) })
  ] });
  return /* @__PURE__ */ e(h, { children: [
    /* @__PURE__ */ t(
      d,
      {
        sections: [
          {
            header: {
              type: "primary",
              title: `About ${n.title}`
            },
            content: n.series_synopsis
          },
          {
            header: {
              type: "secondary",
              title: "Starring"
            },
            content: a === "" ? "" : `<p>${a}</p>`
          },
          {
            header: {
              type: "secondary",
              title: "Director"
            },
            content: n != null && n.director ? `<p>${n == null ? void 0 : n.director}</p>` : ""
          },
          {
            header: {
              type: "secondary",
              title: "Creators"
            },
            content: n != null && n.creators ? `<p>${n == null ? void 0 : n.creators}</p>` : ""
          },
          {
            header: {
              type: "secondary",
              title: "Public & Critical Acclaim"
            },
            content: (n == null ? void 0 : n.public_content) ?? ""
          }
        ]
      }
    ),
    i && l()
  ] });
}
export {
  y as ShowAboutContent,
  y as default
};
